import { BuildPath, getFeatureBranchName } from "@/helpers/Paths"

export function getAndroidAppStoreUrl() {
    const isFeatureBranch = window.location.href.includes("tab-feature.com");
    const isQA = window.location.href.includes("tab-qa.com");

    if (isQA) {
        return `https://appcenter.tab-qa.com/apps/thrive-test-android/`;
    } else if (isFeatureBranch) {
        return `https://appcenter.${getFeatureBranchName(window.location.href)}.tab-feature.com/apps/tf-${getFeatureBranchName(window.location.href)}-android/`
    } else {
        return "https://play.google.com/store/apps/details?id=com.thriveapp.thriveapp"
    }
}

export function getIOSAppStoreUrl() {
    const isFeatureBranch = window.location.href.includes("tab-feature.com");
    const isQA = window.location.href.includes("tab-qa.com");

    if (isQA) {
        return `https://appcenter.tab-qa.com/apps/thrive-test-ios/`;
    } else if (isFeatureBranch) {
        return `https://appcenter.${getFeatureBranchName(window.location.href)}.tab-feature.com/apps/tf-${getFeatureBranchName(window.location.href)}-ios/`
    } else {
        return "https://apps.apple.com/gb/app/thrive-app/id1513335003";
    }
}

const AppStoreButtonPanel = () => {
    const googlePlayUrl = getAndroidAppStoreUrl();
    const appStoreUrl = getIOSAppStoreUrl();

    return (
        <div className="app-store-button-panel">
            <button
                className='app-store-button' 
                onClick={() =>window.open(appStoreUrl, "_blank", "noopener,noreferrer")}
                aria-label="Go to App Store"
            >
                <img src={`${BuildPath()}/images/appStore/appstorebutton.png`} alt=""/>
            </button>
                        
            <button
                className='google-play-button' 
                onClick={()=>  window.open(googlePlayUrl, "_blank", "noopener,noreferrer")}
                aria-label="Go to Google Play Store"
            >
                <img src={`${BuildPath()}/images/appStore/googleplaybutton.png`} alt="" />
            </button>
        </div>
    )
}

export default AppStoreButtonPanel